import Kicker from './Kicker';
import SectionShell from './SectionShell';
import { useTranslation } from 'react-i18next';

function RolloutSection() {
  const { t } = useTranslation();
  const rollout = [
    [t('rollout.phases.p1_phase'), t('rollout.phases.p1_title'), t('rollout.phases.p1_copy')],
    [t('rollout.phases.p2_phase'), t('rollout.phases.p2_title'), t('rollout.phases.p2_copy')],
    [t('rollout.phases.p3_phase'), t('rollout.phases.p3_title'), t('rollout.phases.p3_copy')],
    [t('rollout.phases.p4_phase'), t('rollout.phases.p4_title'), t('rollout.phases.p4_copy')],
  ];
  return (
    <SectionShell id="rollout">
      <div>
        <Kicker>{t('rollout.kicker')}</Kicker>
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
          <h2 className="text-4xl font-black leading-tight sm:text-5xl">{t('rollout.title')}</h2>
          <p className="text-lg leading-8 text-slate-600">{t('rollout.body')}</p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-2">
          {rollout.map(([phase, title, copy], index) => (
            <article key={phase} className="rounded border border-slate-200 bg-white p-6">
              <p
                className={`text-xs font-extrabold uppercase tracking-[0.22em] ${
                  index === 3 ? 'text-emerald-500' : 'text-[#8a96b2]'
                }`}
              >
                {phase}
              </p>
              <h3 className="mt-4 text-2xl font-black">{title}</h3>
              <p className="mt-5 text-base leading-7 text-slate-600">{copy}</p>
            </article>
          ))}
        </div>

        <div className="mt-6 flex flex-col gap-4 rounded bg-[rgb(16_185_129)] px-8 py-6 text-white lg:flex-row lg:items-center">
          <p className="text-xs font-extrabold uppercase text-white lg:w-72">{t('rollout.time_to_value')}</p>
          <div className="hidden h-9 w-px bg-white/25 lg:block" />
          <p className="text-2xl font-black">{t('rollout.time_to_value_copy')}</p>
        </div>
      </div>
    </SectionShell>
  );
}

export default RolloutSection;
